var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overview"},[_c('data-table',{ref:"table",attrs:{"actions":_vm.actions}}),_c('time-modal',{attrs:{"time-shift":_vm.timeShift,"clients":_vm.clients,"persons":_vm.persons,"projects":_vm.projects,"services":_vm.services,"time-types":_vm.timeTypes,"time-entries":_vm.timeEntries,"week":_vm.week}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }